<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newTrainee')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'learning-trainees' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createTrainee" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <trainee-details-card ref="traineeDetailsCard"
                                v-bind:trainee="trainee" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import TraineeDetailsCard from '@/components/learning/TraineeDetailsCard.vue'

  export default {
    components: {
      HeaderButton,
      TopHeader,
      TraineeDetailsCard
    },
    async created() {
      this.loading = true

      await this.loadDepartments()
      await this.loadLearningTenants()

      this.loading = false
    },
    data: () => ({
      loading: false,
      trainee: {},
      validationSnackbar: false
    }),
    methods: {
      async createTrainee() {
        if (!this.$refs.traineeDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateTrainee({ trainee: this.trainee })

        this.$router.push({ name: 'learning-trainees' })
      },
      ...mapActions({
        doCreateTrainee: 'learning/createTrainee',
        loadDepartments: 'common/loadDepartments',
        loadLearningTenants: 'learning/loadLearningTenants'
      })
    },
    name: 'TraineeAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newTrainee": "Neuer Trainee",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newTrainee": "New trainee",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>